export const USER_PERMISSIONS_MAP = {
    ADD_NEW_CONSUMER: 'ADD_NEW_CONSUMER',
    CANCEL_ENRL_REASON_FRAUD_RESCISSION: 'CANCEL_ENRL_REASON_FRAUD_RESCISSION',
    MEMBER_TAG_ACCESS: 'MEMBER_TAG_ACCESS',
    TKM_EDIT_TICKET: 'TKM_EDIT_TICKET',
    TKM_LIST_QUEUE: 'TKM_LIST_QUEUE',
    TKM_LIST_TICKET: 'TKM_LIST_TICKET',
    TKM_MANAGE_CANNED_RESPONSE: 'TKM_MANAGE_CANNED_RESPONSE',
    TKM_MANAGE_EXCHANGE_ASSIGNEES: 'TKM_MANAGE_EXCHANGE_ASSIGNEES',
    TKM_MANAGE_TAGS: 'TKM_MANAGE_TAGS',
    TKM_MANAGE_TICKET_TYPES: 'TKM_MANAGE_TICKET_TYPES',
    TKM_REPORT: 'TKM_REPORT',
} as const;
